import { v4 as uuidv4 } from "uuid"
export const makeDragAndDropData = (resData) => {
    const formattedData = resData?.map((item) => ({
        id: `${item.id}`,
        title: item.label,
    }))
    return [
        {
            id: uuidv4(),
            title: "Zones",
            tasks: formattedData,
        },
        {
            id: uuidv4(),
            title: "Selected Zones",
            tasks: [],
        },
    ]
}

export const makeDragAndDropDataForUpdateAPI = (resData, dataTofilter) => {
    const formattedData = makeDragAndDropData(resData)

    const rightFilteredData = formattedData[0]?.tasks?.filter((item) =>
        dataTofilter?.zone_id?.includes(+item.id),
    )
    const leftFilteredData = formattedData[0]?.tasks?.filter(
        (item) => !dataTofilter?.zone_id?.includes(+item.id),
    )
    return [
        {
            id: uuidv4(),
            title: "Zones ",
            tasks: leftFilteredData,
        },
        {
            id: uuidv4(),
            title: "Selected Zones",
            tasks: rightFilteredData,
        },
    ]
}
